import Vue from "vue";
const instance = new Vue();

export default function toast(type, title, text = "") {
    let options = {
        title: title,
        text: text,
        icon: type,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener("mouseenter", instance.$swal.stopTimer);
            toast.addEventListener("mouseleave", instance.$swal.resumeTimer);
        },
    };
    instance.$swal(options);
}
